module.exports = __webpack_public_path__ + "static/10-identity-469e88c2a52bfa9349f3f311596ed6ae.png";